"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_ui_1 = require("@newfront-insurance/core-ui");
var workflow_1 = require("@newfront-insurance/workflow");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var warning_block_1 = __importDefault(require("../components/warning-block"));
var schemas_1 = require("../lib/schemas");
var types_1 = require("../lib/types");
var NOC_DOC_URL = 'https://www.notion.so/newfront/NOC-workflow-end-to-end-demo-487a4d4305254e8aad69ba8134e09367';
function SelectEndPolicyReason(props) {
    var onSubmit = props.onSubmit, context = props.context;
    var _a = workflow_1.useForm({
        initialValues: {
            primaryReason: context.primaryReason || types_1.PrimaryReason.CUSTOMER_CANCEL,
        },
        validationSchema: schemas_1.verifyPrimaryReasonSchema,
        onSubmit: onSubmit,
    }), form = _a.form, onChange = _a.onChange;
    var isNoc = react_1.useMemo(function () {
        if (form.values.primaryReason === types_1.PrimaryReason.CARRIER_CANCEL) {
            return true;
        }
        return false;
    }, [form.values.primaryReason]);
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(core_ui_1.Card, null,
            react_1.default.createElement("form", { onSubmit: form.handleSubmit },
                react_1.default.createElement(workflow_1.WorkflowContent.Header, { title: "Tell us why this policy is ending" }),
                react_1.default.createElement(workflow_1.WorkflowContent.Body, null,
                    react_1.default.createElement(core_ui_1.Stack, { direction: "vertical", gap: 16 },
                        react_1.default.createElement(core_ui_1.SelectableOptionRowGroup, { boldLabels: true, options: types_1.endPolicyOptions, active: form.values.primaryReason, onChange: onChange('primaryReason') })),
                    isNoc && (react_1.default.createElement(core_ui_1.FadeIn, null,
                        react_1.default.createElement(core_ui_1.Spacing, { height: 16 }),
                        react_1.default.createElement(warning_block_1.default, null,
                            react_1.default.createElement(core_ui_1.Text, null,
                                "Carrier cancellations should be processed through the NOC workflow. Please refer to the",
                                ' ',
                                react_1.default.createElement("a", { href: NOC_DOC_URL, target: "blank" },
                                    "NOC workflow documentation",
                                    react_1.default.createElement(StyledArrowContainer, null,
                                        react_1.default.createElement(core_ui_1.ExternalArrow, { color: core_ui_1.colors.brand[400] }))),
                                ' ',
                                "to learn more about how to process NOCs."))))),
                react_1.default.createElement(workflow_1.WorkflowContent.Footer, { actions: {
                        next: {
                            type: 'submit',
                            text: 'Next',
                            loading: form.isSubmitting,
                            disabled: isNoc || !form.isValid,
                        },
                    } })))));
}
exports.default = SelectEndPolicyReason;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 24px;\n  width: 640px;\n  height: 770px;\n  margin: 0 auto;\n"], ["\n  padding-bottom: 24px;\n  width: 640px;\n  height: 770px;\n  margin: 0 auto;\n"])));
var StyledArrowContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline;\n  svg {\n    display: inline;\n    color: inherit;\n  }\n"], ["\n  display: inline;\n  svg {\n    display: inline;\n    color: inherit;\n  }\n"])));
var templateObject_1, templateObject_2;
